export function csrfToken(): string | null {
  const el = document.querySelector('meta[name="csrf-token"]') as HTMLMetaElement | null;
  return el?.content ?? null;
}

// Helper to send CSRF token for API requests
export function jsonHeaders() {
  const token = csrfToken();
  if (!token) throw new Error("No CSRF token found in page, cannot make API requests");

  return {
    "Content-Type": "application/json",
    Accept: "application/json",
    "X-CSRF-Token": token,
  };
}
